import * as Models from '../';

export interface ISearchSolarAccountsRequest {
  customer: Models.Customer.Customer.Customer;
  serviceAddress: Models.Customer.Address.Address;
  includeInactiveCustomer: boolean;
  trustName: string;
  skip: number;
  take: number;
}
export class SearchSolarAccountsRequest implements ISearchSolarAccountsRequest {
  customer: Models.Customer.Customer.Customer;
  serviceAddress: Models.Customer.Address.Address;
  includeInactiveCustomer = false;
  trustName: string;
  skip = 0;
  take = 20;
}
